import React from 'react';
import { FeedShimmer, ShimmerEffect } from './styles';

// import { Container } from './styles';

const LoadingStateFeed: React.FC = () => {
  return (
    <FeedShimmer>
      <ShimmerEffect />
      <ShimmerEffect />
    </FeedShimmer>
  );
};

export default LoadingStateFeed;
